import ProjectSubscribeToNotificationsModule from './project-subscribe-to-notifications.module'

export default ProjectSubscribeToNotificationsModule
